import React, { useContext, useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  // DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import Alert from '@material-ui/lab/Alert';

import PropTypes from 'prop-types';

import BasicButton from '../buttons/basicButton';
import CustomCheckBox from '../fields/customCheckBox';
import SpinnerLoading from '../feedback/spinnerLoading';

import { addCliniciansToProgram, getPrograms } from '../../utils/comms';
import { clinicianRoles } from '../../utils/constants';

import translations from '../../languages/i18n';

import { customOptionsTableStyles } from '../../styles/formElementsStyles';

import { SessionContext } from '../../utils/context';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function AddProgramsDialog({ clinicianPrograms, handleClose, handleFeedback, idUser, open, title }) {
  const classes = useStyles();

  const sessionContext = useContext(SessionContext);
  const bgColors = customOptionsTableStyles();

  const [emptySelectionWarning, setEmptySelectionWarning] = useState(false);
  const [ready, setReady] = useState(false);
  // const [roles, setRoles] = useState([]);
  const [selectedPrograms, setSelectedPrograms] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [programsList, setProgramsList] = useState([]);

  useEffect(() => {
    const getProgramsFromServer = async () => {
      setShowLoading(true);
      const response = await getPrograms(sessionContext.userToken);
      setShowLoading(false);
      if (response.status === 200) { // Tenim llistat
        let listOfPrograms = [];
        if (sessionContext.role === 'Admin') {
          // Si l'usuari és l'Administrador del sistema pot enrolar a tots els programes
          listOfPrograms = response.data.programs;
        } else {
          // Si l'usuari és un clínic administrador, només pot enrolar als programes que administra
          listOfPrograms = response.data.programs.filter((program) => {
            // Agafam els programes on el clínic és administrador
            return program.accessibleBy.clinicians.find((clinician) => clinician.clinician !== null && clinician.clinician._id === sessionContext.userId && clinician.admin === true);
          });
        }
        // Filtram la llista de programes de manera que només es mostrin els programes on encara el clínic no en forma part
        const filteredListOfPrograms = listOfPrograms.filter((program) => {
          return !clinicianPrograms.some((prog) => prog._id === program._id);
        });
        setProgramsList(filteredListOfPrograms);
        setReady(true);
      } else if (response === 400) { // Error amb les dades
        console.log('Error 400');
      } else { // Login KO. Altres errors
        console.log(response);
      }
    };
    getProgramsFromServer();
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render

  const closeDialog = () => {
    handleClose(false); // Amb false indicam al handleClose que el pare NO ha de mostrar la nova llista de programes
  };

  const addPrograms = async () => {
    if (selectedPrograms.length !== 0) { // Al manco ha seleccionat un programa del llistat
      setShowLoading(true);
      const responseProgramTeam = await Promise.all(selectedPrograms.map((element) => addCliniciansToProgram(
        [{ clinician: idUser, admin: element.role === 'admin' }],
        element.id,
        sessionContext.userToken,
      )));
      setShowLoading(false);
      // Comprovam si dins les respostes n'hi ha alguna de timeOut o erronia
      const allOk = responseProgramTeam.map((answer) => {
        if (answer.status && answer.status === 200) return 'ok';
        if (answer === 'timeOut') return 'timeOut';
        return 'error';
      });
      const idTO = allOk.indexOf('timeOut');
      const idE = allOk.indexOf('error');
      setSelectedPrograms([]); // Ha d'estar abans del HandleClose sinó intenta modificar l'estat d'un component desmontat
      if (idTO > -1 || idE > -1) { // Al manco hi ha 1 timeOut o 1 error
        // Miram si algun dels errors rebuts és un timeOut
        if (idTO > -1) { // Hi ha hagut un timeOut
          handleFeedback('error', 'TimeOut');
        } else { // Hi ha hagut un error
          handleFeedback('error', 'AddCliniciansToProgram');
        }
      } else { // No hi ha cap error
        handleClose(true); // Amb true indicam al handleClose que el pare ha de mostrar la nova llista de programes
        handleFeedback('success', 'AddCliniciansToProgram');
      }
    } else if (programsList.length !== 0) { // Si no ha seleccionat cap programa però el llistat no es buit, avisam a l'usuari
      setEmptySelectionWarning(true);
    } else {
      closeDialog();
    }
  };

  const handleCheck = (id) => {
    const selectedProgramsCopy = selectedPrograms.slice();
    // Cercam si dins selectedProgramsCopy hi ha el valor de program
    const idx = selectedProgramsCopy.findIndex((item) => item.id === id);
    if (idx < 0) selectedProgramsCopy.push({ id, role: 'normal' }); // Si idx és -1 vol dir que no ha trobat el valor, l'afegim a la taula amb el valor del role per defecte
    else selectedProgramsCopy.splice(idx, 1); // L'ha trobat, l'eliminam de la taula
    setSelectedPrograms(selectedProgramsCopy);
    setEmptySelectionWarning(false);
  };

  const handleChange = (id, role) => {
    const selectedProgramsCopy = selectedPrograms.slice();
    // Cercam si dins selectedProgramsCopy hi ha el valor de program
    const idx = selectedProgramsCopy.findIndex((item) => item.id === id);
    if (role === 'none') {
      // Si role és none, si és dins selectedPrograms el llevam
      if (idx > -1) selectedProgramsCopy.splice(idx, 1);
    } else if (idx < 0) {
      selectedProgramsCopy.push({ id, role }); // Si idx és -1 vol dir que no ha trobat el valor, l'afegim a la taula
    } else {
      selectedProgramsCopy[idx].role = role; // L'ha trobat actualitzam el valor de role
    }
    setSelectedPrograms(selectedProgramsCopy);
  };
  const selectValue = (id) => {
    const idx = selectedPrograms.findIndex((item) => item.id === id);
    if (idx > -1) {
      // El programa és dins selectedPrograms, tornam el valor que hi té
      return selectedPrograms[idx].role;
    }
    // El programa NO és dins selectedPrograms, tornam el valor per defecte del role
    return clinicianRoles[0].value; // Valor per defecte
  };

  const listOfPrograms = (programsData) => {
    return (
      <TableContainer component={Paper}>
        <Table aria-label='programs list table'>
          <TableBody>
            <TableRow className={bgColors.tableRowHeaderBgColor}>
              {/* ATENCIÓ: no pintam la columna _id */}
              <TableCell align='left'><strong>{translations['_name']}</strong></TableCell>
              <TableCell align='left'><strong>{translations['_role']}</strong></TableCell>
              <TableCell align='left'></TableCell>
            </TableRow>
            {(programsData.length !== 0 && (
              programsData.map((data, index) => (
                <TableRow key={data._id} className={index % 2 ? bgColors.tableRowBgColor1 : bgColors.tableRowBgColor2} hover>
                  {/* ATENCIÓ: no pintam la columna _id */}
                  <TableCell align='left'>{translations[data.sharedId] || data.name}</TableCell>
                  <TableCell align='left'>
                    <FormControl fullWidth>
                      <InputLabel id='clinicianRole-label'>{translations['_role']}</InputLabel>
                      <Select
                        labelId='clinicianRole-label'
                        id='role'
                        name='role'
                        value={selectValue(data._id)}
                        onChange={(value) => handleChange(data._id, value.target.value)}
                        label={translations['_role']}
                        displayEmpty
                        className={classes.selectEmpty}
                      >
                        {clinicianRoles.map((element) => <MenuItem key={`clinicianRoles_${element.value}`} value={element.value}>{element.description}</MenuItem>)}
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell align='center'>
                    <CustomCheckBox
                      checked={selectedPrograms.findIndex((item) => item.id === data._id) > -1} // Si res.value es dins la taula la condició dona true
                      onClick={() => handleCheck(data._id)}
                    />
                  </TableCell>
                </TableRow>
              ))
            )) || (
              <TableRow>
                <TableCell align='center' colSpan='3'>
                  <Typography variant='h6' component='div'>{translations['_emptyProgramListClinician']}</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <div>
      <Dialog
        open={open}
        // onClose={(handleClose2}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        fullWidth
        maxWidth='sm'
      >
        <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          <SpinnerLoading show={showLoading} />
          <Grid container spacing={2} justify='space-around' direction='column'>
            <Grid item xs={12}>
              {ready && listOfPrograms(programsList)}
            </Grid>
            {emptySelectionWarning && (
            <Grid item xs={12}>
              <Alert severity='error'>{translations['_emptyProgramsSelection']}</Alert>
            </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <BasicButton handleClick={addPrograms} type='accept' /> {/* Per enviar el formulari des d'un botó meu, sinó s'ha d'emprar un Button type='submit' */}
          <BasicButton handleClick={closeDialog} type='cancel' />
        </DialogActions>
      </Dialog>
    </div>
  );
}

// Indica i controla els props que se han de passar al component
AddProgramsDialog.propTypes = {
  clinicianPrograms: PropTypes.array.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  idUser: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
